{
  "schemaVersion": 1,
  "blueprintId": "example-canal-house-v1",
  "catalogId": "testcs-building-core-v1",
  "name": "Ночной дом у канала",
  "description": "Готовый узкий двухэтажный дом 4×8 м для атомарной установки на участке. Все элементы используют оригинальный модульный каталог TESTCS.",
  "author": {
    "id": "testcs-system",
    "displayName": "TESTCS"
  },
  "license": "TESTCS-original",
  "createdAt": "2026-07-24T00:00:00.000Z",
  "coordinateSystem": {
    "upAxis": "Y",
    "forwardAxis": "-Z",
    "positionOrder": ["x", "y", "z"]
  },
  "footprint": {
    "sizeM": [4, 8],
    "heightM": 8.5,
    "pivotM": [0, 0, 2],
    "entranceDirection": "-Z"
  },
  "plotRequirements": {
    "minimumSizeM": [6, 11],
    "minimumBuildHeightM": 9,
    "allowedZones": ["residential", "mixed-use", "sandbox"],
    "terrain": {
      "maxSlopeDeg": 8,
      "flattenFootprint": true,
      "allowsWater": false
    },
    "clearanceM": {
      "front": 2,
      "back": 1,
      "left": 1,
      "right": 1
    }
  },
  "placement": {
    "mode": "atomic",
    "collisionPolicy": "reject",
    "outOfPlotPolicy": "reject",
    "rotationStepDeg": 90,
    "allowMirror": false,
    "rollbackOnFailure": true
  },
  "permissions": {
    "ownerCanEdit": true,
    "editorsCanEdit": true,
    "visitorsCanUseDoors": true,
    "visitorsCanUseFurniture": true,
    "visitorsCanMoveFurniture": false,
    "aiBuilderPolicy": "owner-or-delegated"
  },
  "budget": {
    "maxElements": 64,
    "maxCredits": 2500,
    "maxDynamicLights": 2
  },
  "elements": [
    {
      "id": "foundation-front",
      "moduleId": "foundation-stone-4x4",
      "grounded": true,
      "transform": {"positionM": [0, 0, 0], "rotationDeg": [0, 0, 0], "scale": [1, 1, 1]}
    },
    {
      "id": "foundation-rear",
      "moduleId": "foundation-stone-4x4",
      "parentId": "foundation-front",
      "grounded": true,
      "snap": {"parentPointId": "edge-s", "ownPointId": "edge-n"},
      "transform": {"positionM": [0, 0, 4], "rotationDeg": [0, 0, 0], "scale": [1, 1, 1]}
    },
    {
      "id": "ground-floor-front",
      "moduleId": "floor-stone-4x4",
      "parentId": "foundation-front",
      "snap": {"parentPointId": "top", "ownPointId": "bottom"},
      "supportIds": ["foundation-front"],
      "transform": {"positionM": [0, 0.4, 0], "rotationDeg": [0, 0, 0], "scale": [1, 1, 1]}
    },
    {
      "id": "ground-floor-rear",
      "moduleId": "floor-oak-4x4",
      "parentId": "foundation-rear",
      "snap": {"parentPointId": "top", "ownPointId": "bottom"},
      "supportIds": ["foundation-rear"],
      "transform": {"positionM": [0, 0.4, 4], "rotationDeg": [0, 0, 0], "scale": [1, 1, 1]}
    },
    {
      "id": "ground-front-door",
      "moduleId": "door-canal-brick-4x3",
      "parentId": "ground-floor-front",
      "snap": {"parentPointId": "wall-n", "ownPointId": "base"},
      "supportIds": ["ground-floor-front"],
      "transform": {"positionM": [0, 0.64, -2], "rotationDeg": [0, 0, 0], "scale": [1, 1, 1]},
      "state": {"locked": true, "accessGroup": "plot-members"}
    },
    {
      "id": "ground-rear-wall",
      "moduleId": "window-sash-brick-4x3",
      "parentId": "ground-floor-rear",
      "snap": {"parentPointId": "wall-s", "ownPointId": "base"},
      "supportIds": ["ground-floor-rear"],
      "transform": {"positionM": [0, 0.64, 6], "rotationDeg": [0, 180, 0], "scale": [1, 1, 1]}
    },
    {
      "id": "ground-east-front-wall",
      "moduleId": "wall-brick-solid-4x3",
      "parentId": "ground-floor-front",
      "snap": {"parentPointId": "wall-e", "ownPointId": "base"},
      "supportIds": ["ground-floor-front"],
      "transform": {"positionM": [2, 0.64, 0], "rotationDeg": [0, -90, 0], "scale": [1, 1, 1]}
    },
    {
      "id": "ground-east-rear-wall",
      "moduleId": "wall-brick-solid-4x3",
      "parentId": "ground-floor-rear",
      "snap": {"parentPointId": "wall-e", "ownPointId": "base"},
      "supportIds": ["ground-floor-rear"],
      "transform": {"positionM": [2, 0.64, 4], "rotationDeg": [0, -90, 0], "scale": [1, 1, 1]}
    },
    {
      "id": "ground-west-front-wall",
      "moduleId": "wall-brick-solid-4x3",
      "parentId": "ground-floor-front",
      "snap": {"parentPointId": "wall-w", "ownPointId": "base"},
      "supportIds": ["ground-floor-front"],
      "transform": {"positionM": [-2, 0.64, 0], "rotationDeg": [0, 90, 0], "scale": [1, 1, 1]}
    },
    {
      "id": "ground-west-rear-wall",
      "moduleId": "wall-brick-solid-4x3",
      "parentId": "ground-floor-rear",
      "snap": {"parentPointId": "wall-w", "ownPointId": "base"},
      "supportIds": ["ground-floor-rear"],
      "transform": {"positionM": [-2, 0.64, 4], "rotationDeg": [0, 90, 0], "scale": [1, 1, 1]}
    },
    {
      "id": "stairs",
      "moduleId": "stairs-oak-straight-4x3",
      "parentId": "ground-floor-rear",
      "snap": {"parentPointId": "top", "ownPointId": "base"},
      "supportIds": ["ground-floor-rear"],
      "transform": {"positionM": [1.1, 0.64, 3.8], "rotationDeg": [0, 180, 0], "scale": [1, 1, 1]}
    },
    {
      "id": "upper-floor-front",
      "moduleId": "floor-oak-4x4",
      "parentId": "ground-front-door",
      "snap": {"parentPointId": "top", "ownPointId": "bottom"},
      "supportIds": ["ground-front-door", "ground-east-front-wall", "ground-west-front-wall"],
      "transform": {"positionM": [0, 3.64, 0], "rotationDeg": [0, 0, 0], "scale": [1, 1, 1]}
    },
    {
      "id": "upper-floor-rear",
      "moduleId": "floor-oak-4x4",
      "parentId": "ground-rear-wall",
      "snap": {"parentPointId": "top", "ownPointId": "bottom"},
      "supportIds": ["ground-rear-wall", "ground-east-rear-wall", "ground-west-rear-wall"],
      "transform": {"positionM": [0, 3.64, 4], "rotationDeg": [0, 0, 0], "scale": [1, 1, 1]}
    },
    {
      "id": "upper-front-window",
      "moduleId": "window-sash-brick-4x3",
      "parentId": "upper-floor-front",
      "snap": {"parentPointId": "wall-n", "ownPointId": "base"},
      "supportIds": ["upper-floor-front"],
      "transform": {"positionM": [0, 3.84, -2], "rotationDeg": [0, 0, 0], "scale": [1, 1, 1]}
    },
    {
      "id": "upper-rear-window",
      "moduleId": "window-sash-brick-4x3",
      "parentId": "upper-floor-rear",
      "snap": {"parentPointId": "wall-s", "ownPointId": "base"},
      "supportIds": ["upper-floor-rear"],
      "transform": {"positionM": [0, 3.84, 6], "rotationDeg": [0, 180, 0], "scale": [1, 1, 1]}
    },
    {
      "id": "upper-east-front-wall",
      "moduleId": "wall-brick-solid-4x3",
      "parentId": "upper-floor-front",
      "snap": {"parentPointId": "wall-e", "ownPointId": "base"},
      "supportIds": ["upper-floor-front"],
      "transform": {"positionM": [2, 3.84, 0], "rotationDeg": [0, -90, 0], "scale": [1, 1, 1]}
    },
    {
      "id": "upper-east-rear-wall",
      "moduleId": "wall-brick-solid-4x3",
      "parentId": "upper-floor-rear",
      "snap": {"parentPointId": "wall-e", "ownPointId": "base"},
      "supportIds": ["upper-floor-rear"],
      "transform": {"positionM": [2, 3.84, 4], "rotationDeg": [0, -90, 0], "scale": [1, 1, 1]}
    },
    {
      "id": "upper-west-front-wall",
      "moduleId": "wall-brick-solid-4x3",
      "parentId": "upper-floor-front",
      "snap": {"parentPointId": "wall-w", "ownPointId": "base"},
      "supportIds": ["upper-floor-front"],
      "transform": {"positionM": [-2, 3.84, 0], "rotationDeg": [0, 90, 0], "scale": [1, 1, 1]}
    },
    {
      "id": "upper-west-rear-wall",
      "moduleId": "wall-brick-solid-4x3",
      "parentId": "upper-floor-rear",
      "snap": {"parentPointId": "wall-w", "ownPointId": "base"},
      "supportIds": ["upper-floor-rear"],
      "transform": {"positionM": [-2, 3.84, 4], "rotationDeg": [0, 90, 0], "scale": [1, 1, 1]}
    },
    {
      "id": "roof-front",
      "moduleId": "roof-gable-tile-4x4",
      "parentId": "upper-front-window",
      "snap": {"parentPointId": "top", "ownPointId": "bottom"},
      "supportIds": ["upper-front-window", "upper-east-front-wall", "upper-west-front-wall"],
      "transform": {"positionM": [0, 6.84, 0], "rotationDeg": [0, 0, 0], "scale": [1, 1, 1]}
    },
    {
      "id": "roof-rear",
      "moduleId": "roof-dormer-tile-4x4",
      "parentId": "upper-rear-window",
      "snap": {"parentPointId": "top", "ownPointId": "bottom"},
      "supportIds": ["upper-rear-window", "upper-east-rear-wall", "upper-west-rear-wall"],
      "transform": {"positionM": [0, 6.84, 4], "rotationDeg": [0, 0, 0], "scale": [1, 1, 1]}
    },
    {
      "id": "sofa",
      "moduleId": "furniture-sofa-2seat",
      "parentId": "ground-floor-front",
      "snap": {"parentPointId": "top", "ownPointId": "base"},
      "supportIds": ["ground-floor-front"],
      "transform": {"positionM": [-0.7, 0.88, 0.7], "rotationDeg": [0, 0, 0], "scale": [1, 1, 1]}
    },
    {
      "id": "dining-table",
      "moduleId": "furniture-table-dining",
      "parentId": "ground-floor-rear",
      "snap": {"parentPointId": "top", "ownPointId": "base"},
      "supportIds": ["ground-floor-rear"],
      "transform": {"positionM": [-0.6, 0.84, 4.1], "rotationDeg": [0, 0, 0], "scale": [1, 1, 1]}
    },
    {
      "id": "bed",
      "moduleId": "furniture-bed-double",
      "parentId": "upper-floor-rear",
      "snap": {"parentPointId": "top", "ownPointId": "base"},
      "supportIds": ["upper-floor-rear"],
      "transform": {"positionM": [0, 3.84, 4.25], "rotationDeg": [0, 90, 0], "scale": [1, 1, 1]}
    },
    {
      "id": "cabinet",
      "moduleId": "furniture-cabinet-tall",
      "parentId": "upper-floor-front",
      "snap": {"parentPointId": "top", "ownPointId": "base"},
      "supportIds": ["upper-floor-front"],
      "transform": {"positionM": [1.35, 3.84, 0.85], "rotationDeg": [0, -90, 0], "scale": [1, 1, 1]}
    },
    {
      "id": "entrance-light",
      "moduleId": "light-wall-canal",
      "parentId": "ground-front-door",
      "snap": {"parentPointId": "surface", "ownPointId": "wall"},
      "supportIds": ["ground-front-door"],
      "transform": {"positionM": [1.15, 2.55, -2.2], "rotationDeg": [0, 180, 0], "scale": [1, 1, 1]},
      "state": {"enabled": true, "color": "#ffcf8a", "dynamicLight": false}
    },
    {
      "id": "window-planter",
      "moduleId": "furniture-planter-window",
      "parentId": "upper-floor-front",
      "snap": {"parentPointId": "top", "ownPointId": "base"},
      "supportIds": ["upper-floor-front"],
      "transform": {"positionM": [0, 4.7, -2.22], "rotationDeg": [0, 0, 0], "scale": [1, 1, 1]}
    }
  ],
  "aiIntent": {
    "style": ["amsterdam-inspired", "warm-interior", "night-friendly"],
    "hardConstraints": [
      "Keep the entrance unobstructed",
      "Keep stairs and landings walkable",
      "Do not move load-bearing exterior walls",
      "Stay inside the assigned plot"
    ],
    "editableZones": ["ground-floor-interior", "upper-floor-interior", "facade-decoration"],
    "defaultTasks": ["furnish", "decorate", "repair", "seasonal-lighting"]
  }
}
